export const defaultTraceDetectionPreferences = {
    Benzodiazepine: false,
    Fentanyl: false,
    Heroin: false,
    Hydromorphone: false,
    Medetomidine: true,
    Xylazine: false,
};

export const traceDetectionPreferenceKeys = Object.keys(defaultTraceDetectionPreferences);

export const mergeTraceDetectionPreferences = preferencesFromDB => {
    const preferences = { ...defaultTraceDetectionPreferences };

    if (!preferencesFromDB || typeof preferencesFromDB !== 'object' || Array.isArray(preferencesFromDB)) {
        return preferences;
    }

    traceDetectionPreferenceKeys.forEach(key => {
        if (typeof preferencesFromDB[key] === 'boolean') {
            preferences[key] = preferencesFromDB[key];
        }
    });

    return preferences;
};
